import { cloneDeep } from '@src/utils/functions/utils'
import { AssignedExperimentBuckets } from '../experiments.types'

const experimentManagerData = {
  assignedBuckets: {} as AssignedExperimentBuckets,
}

export const setAssignedExperimentBuckets = (assignedExperimentBuckets: AssignedExperimentBuckets) => {
  experimentManagerData.assignedBuckets = Object.freeze(cloneDeep(assignedExperimentBuckets))
}

export const getAssignedExperimentBuckets = (): AssignedExperimentBuckets =>
  cloneDeep(experimentManagerData.assignedBuckets)
